"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceListQuery = exports.DynamicResourceCreate = exports.ResourceVersionSummary = exports.ResourceSummary = exports.ResourceFolderCreate = exports.ResourceFolderSummary = exports.NameI18n = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
exports.NameI18n = zod_1.z.object({
    fr: zod_1.z.string().min(1).max(255),
    en: zod_1.z.string().max(255).optional(),
});
exports.ResourceFolderSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    parent_id: zod_1.z.string().uuid().nullable(),
    name_i18n: exports.NameI18n,
    created_at: zod_1.z.string().datetime(),
});
exports.ResourceFolderCreate = zod_1.z.object({
    parent_id: zod_1.z.string().uuid().nullable(),
    name_i18n: exports.NameI18n,
});
exports.ResourceSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    folder_id: zod_1.z.string().uuid().nullable(),
    kind: zod_1.z.enum(enums_js_1.ResourceKinds),
    name_i18n: exports.NameI18n,
    state: zod_1.z.enum(enums_js_1.ResourceStates),
    current_version_id: zod_1.z.string().uuid().nullable(),
    created_at: zod_1.z.string().datetime(),
});
exports.ResourceVersionSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    resource_id: zod_1.z.string().uuid(),
    version_number: zod_1.z.number().int().positive(),
    payload_kind: zod_1.z.enum(['bytes', 'source']),
    state: zod_1.z.enum(enums_js_1.ResourceStates),
    bytes_sha256: zod_1.z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    size_bytes: zod_1.z.number().int().nonnegative().nullable(),
    content_type: zod_1.z.string().nullable(),
    duration_ms: zod_1.z.number().int().nonnegative().nullable(),
    width: zod_1.z.number().int().positive().nullable(),
    height: zod_1.z.number().int().positive().nullable(),
    source_url: zod_1.z.string().url().nullable(),
    source_kind: zod_1.z.enum(['rss', 'web_page']).nullable(),
    cached_snapshot_sha256: zod_1.z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    last_fetched_at: zod_1.z.string().datetime().nullable(),
    signed_manifest_id: zod_1.z.string().uuid().nullable(),
    created_at: zod_1.z.string().datetime(),
});
exports.DynamicResourceCreate = zod_1.z.object({
    name_i18n: exports.NameI18n,
    folder_id: zod_1.z.string().uuid().nullable(),
    kind: zod_1.z.enum(['rss_feed', 'web_page']),
    source_url: zod_1.z.string().url(),
    fetch_config: zod_1.z
        .object({
        category_filters: zod_1.z.array(zod_1.z.string()).optional(),
        keyword_filters: zod_1.z.array(zod_1.z.string()).optional(),
        max_age_seconds: zod_1.z.number().int().positive().optional(),
        max_items: zod_1.z.number().int().positive().max(50).optional(),
    })
        .default({}),
    sanitizer_profile: zod_1.z.enum(['rss_html_v1', 'webpage_strict_v1']),
});
exports.ResourceListQuery = zod_1.z.object({
    folder: zod_1.z.string().uuid().optional(),
    kind: zod_1.z.enum(enums_js_1.ResourceKinds).optional(),
    state: zod_1.z.enum(enums_js_1.ResourceStates).optional(),
    search: zod_1.z.string().max(128).optional(),
    page: zod_1.z.coerce.number().int().positive().default(1),
    per_page: zod_1.z.coerce.number().int().min(10).max(100).default(20),
});
//# sourceMappingURL=resource.schema.js.map